function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M389.957 255.282h144"
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 248.867,
  cy: 443.498,
  rx: 39.5,
  ry: 12.4,
  transform: "rotate(-69.082 203.353 457.179)",
  fill: "#2f2e41"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1111.335 509.296C1127 625.885 1105.668 742.6 997.166 788.049s-233.305-5.666-278.754-114.168 61.785-173.424 114.17-278.754c106.375-213.893 230.103-247.896 278.753 114.169z",
  fill: "#f2f2f2"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 916,
  cy: 794.436,
  rx: 170,
  ry: 23.127,
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M811.183 758.709l-6.395-23.133 41.446-11.457 6.394 23.133z"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 844.359,
  cy: 777.24,
  rx: 7.5,
  ry: 20,
  transform: "rotate(-15.452 699.072 915.328)",
  fill: "#2f2e41"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 965.361,
  cy: 688.069,
  rx: 39.5,
  ry: 12.4,
  transform: "rotate(-82.281 925.041 695.273)",
  fill: "#2f2e41"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 915.585,
  cy: 728.299,
  r: 79,
  fill: "#2f2e41"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M811.183 744.709l-6.395-23.133 41.446-11.457 6.394 23.133z"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 844.359,
  cy: 763.24,
  rx: 7.5,
  ry: 20,
  transform: "rotate(-15.452 699.072 901.328)",
  fill: "#2f2e41"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 936.329,
  cy: 683.043,
  r: 27,
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 944.963,
  cy: 671.116,
  r: 9,
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1006.815 782.588c29.234-1.464 51.624-28.808 50.01-61.077s-26.624-57.24-55.859-55.777-33.822 24.412-32.207 56.68 8.821 61.637 38.056 60.174z",
  fill: "#899689"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M883.298 694.874a18 18 0 01-2.904-35.883c9.908-.802 12.61 7.065 13.413 16.973s-.6 18.108-10.51 18.91z",
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M49.464 361.025h442.493l68.603 33.422 109.306 53.252 71.468-133.812h202.24"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 222.811,
  cy: 375.025,
  r: 13.685,
  fill: "#899689"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 350.541,
  cy: 361.025,
  r: 13.685,
  fill: "#899689"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 560.384,
  cy: 394.478,
  r: 13.685,
  fill: "#899689"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 855.379,
  cy: 313.887,
  r: 13.685,
  fill: "#899689"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 712.443,
  cy: 367.108,
  r: 13.685,
  fill: "#899689"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 427.576,
  cy: 581.441,
  r: 14.756,
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2
});

var _ref22 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 170,
  cy: 809.436,
  rx: 170,
  ry: 23.127,
  fill: "#3f3d56"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 160.805,
  cy: 696.436,
  r: 79,
  fill: "#2f2e41"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M124.805 758.436h24v43h-24zM172.805 758.436h24v43h-24z"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 144.805,
  cy: 801.936,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref26 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 192.805,
  cy: 800.936,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 162.805,
  cy: 676.436,
  r: 27,
  fill: "#fff"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 162.805,
  cy: 676.436,
  r: 9,
  fill: "#3f3d56"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M84.172 622.969c-6.379-28.568 14.012-57.434 45.544-64.475s62.265 10.41 68.644 38.977-14.519 39.104-46.05 46.145-61.76 7.92-68.138-20.647z",
  fill: "#899689"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 133.805,
  cy: 469.436,
  r: 79,
  fill: "#2f2e41"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M97.805 531.436h24v43h-24zM145.805 531.436h24v43h-24z"
});

var _ref32 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 117.805,
  cy: 574.936,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref33 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 165.805,
  cy: 573.936,
  rx: 20,
  ry: 7.5,
  fill: "#2f2e41"
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.805,
  cy: 449.436,
  r: 27,
  fill: "#fff"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.805,
  cy: 449.436,
  r: 9,
  fill: "#3f3d56"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M57.172 395.969c-6.379-28.568 14.012-57.434 45.544-64.475s62.265 10.41 68.644 38.977-14.519 39.104-46.05 46.145-61.76 7.92-68.138-20.647z",
  fill: "#899689"
});

var _ref37 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 86.867,
  cy: 466.498,
  rx: 12.4,
  ry: 39.5,
  transform: "rotate(-64.626 39.19 482.875)",
  fill: "#2f2e41"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M95 497.936c0 7.732 19.909 23 42 23s42.805-21.768 42.805-29.5-20.714 1.5-42.805 1.5-42-2.732-42 5z",
  fill: "#fff"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  fill: "#899689",
  d: "M835.474 564.71h126.129v64.161H835.474z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M825.603 575.129h126.129v64.161H825.603z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff6584",
  d: "M226.603 199h36v36h-36z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M217.603 187h36v36h-36z"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 906.052,
  cy: 189.47,
  r: 79,
  fill: "#2f2e41"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M960.178 286.373l-23.616 4.275-7.66-42.312 23.617-4.275zM912.948 294.928l-23.616 4.276-7.66-42.313 23.616-4.275z"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 939.065,
  cy: 336.103,
  rx: 20,
  ry: 7.5,
  transform: "rotate(-40.261 872.05 376.593)",
  fill: "#2f2e41"
});

var _ref46 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 985.313,
  cy: 327.731,
  rx: 20,
  ry: 7.5,
  transform: "rotate(-40.261 918.298 368.22)",
  fill: "#2f2e41"
});

var _ref47 = /*#__PURE__*/React.createElement("circle", {
  cx: 900.521,
  cy: 170.146,
  r: 27,
  fill: "#fff"
});

var _ref48 = /*#__PURE__*/React.createElement("circle", {
  cx: 889.424,
  cy: 160.468,
  r: 9,
  fill: "#3f3d56"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M968.372 103.527c1.188-29.247-24.019-54.02-56.3-55.331s-59.416 21.335-60.604 50.582 21.253 35.892 53.535 37.203 62.181-3.207 63.37-32.454z",
  fill: "#899689"
});

var _ref50 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 875.15,
  cy: 208.796,
  rx: 12.4,
  ry: 39.5,
  transform: "rotate(-77.09 832.967 218.322)",
  fill: "#2f2e41"
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1030.224,
  cy: 234.584,
  rx: 12.4,
  ry: 39.5,
  transform: "rotate(-77.09 988.041 244.11)",
  fill: "#2f2e41"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M927.75 220.603a18 18 0 11-35.425 6.413c-1.77-9.782 5.793-13.244 15.575-15.015s18.079-1.18 19.85 8.602z",
  fill: "#fff"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M712.603 99l91 70"
});

var _ref54 = /*#__PURE__*/React.createElement("circle", {
  cx: 669.603,
  cy: 68,
  r: 68,
  fill: "#ff6584"
});

var _ref55 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 935.71,
  cy: 706.84,
  rx: 39.5,
  ry: 12.4,
  transform: "rotate(-82.281 895.39 714.044)",
  fill: "#2f2e41"
});

var _ref56 = /*#__PURE__*/React.createElement("circle", {
  cx: 68.811,
  cy: 786.025,
  r: 13.685,
  fill: "#899689"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff6584",
  d: "M256.603 770h36v36h-36z"
});

var _ref58 = /*#__PURE__*/React.createElement("circle", {
  cx: 256.811,
  cy: 794.025,
  r: 13.685,
  fill: "#899689"
});

var _ref59 = /*#__PURE__*/React.createElement("circle", {
  cx: 461.957,
  cy: 255.025,
  r: 13.685,
  fill: "#899689"
});

var _ref60 = /*#__PURE__*/React.createElement("circle", {
  cx: 727.721,
  cy: 679.252,
  r: 6.535,
  fill: "#ff6584"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  stroke: "#3f3d56",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M759.739 787.725v-74.412"
});

var _ref62 = /*#__PURE__*/React.createElement("circle", {
  cx: 759.739,
  cy: 713.313,
  r: 10.523,
  fill: "#3f3d56"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M759.74 759.175s-1.504-32.332-32.32-28.574",
  fill: "#3f3d56"
});

var SvgChill = function SvgChill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 1115.914,
    height: 832.564,
    viewBox: "0 0 1115.914 832.564"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63);
};

export default "data:image/svg+xml;base64,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";
export { SvgChill as ReactComponent };